import styled from 'styled-components';

import { Spacing } from '@doordash/design-language';
import { Row, Typography } from 'top-component-library';

export const CartItemsListContainer = styled.div``;

export const CustomerSection = styled.div``;

export const CustomerHeader = styled.div``;

export const CartItemsListRow = styled(Row)`
  border-bottom: 1px solid #d8d8d8;

  &:first-child {
    border-top: 1px solid #d8d8d8;
  }
`;

export const CustomerName = styled(Typography.Title)`
  &&& {
    font-size: 2rem;
    font-weight: 400;
  }
`;

export const ItemsCount = styled(Typography.Text)``;

export const EditText = styled(Typography.Text)``;

export const Spacer = styled.div`
  height: ${Spacing.Small}px;
  width: 100%;
`;
